<template>
	<div>
		<div class="imgRightTop">
			<img src="@/assets/images/exposition/xunidianchang-huandianzhan.png" alt="" srcset="">
			<div class="tankuang">
				<div class="tankuang-top">
					<div class="tankuang-top-left"> 换电站</div>
					<div class="tankuang-top-center">类型：{{target[0].type}}</div>
					<div class="tankuang-top-right">规格：{{target[1].rated_battery_number}}仓位*30kw/单个电池</div>
				</div>
				<div class="tankuang-bottom">
					<div class="tankuang-bottom-left">
						<tankuangEcharts1></tankuangEcharts1>
					</div>
					<div class="tankuang-bottom-right">
						<div class="jiankong" v-if="showVideo">
							<video width="624px" height="330px" :ref="`my-player`" :playUrl="url"
								class="videoa video-js" muted></video>
							<!-- <video width="624px" height="330px" class="video" muted autoplay loop src="https://sass.gclme.com/api/file/Image/annex/20230825_c3d105f2b07940d89c385ec4ce16585e.mp4"></video> -->
						</div>
					</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	import tankuangEcharts1 from "./tankuangEcharts1.vue";
	import {
		dataInterface
	} from '@/api/dataInterfaceApi';
	export default {
		components: {
			tankuangEcharts1
		},
		data() {
			return {
				target: [{
						type: "",
					},
					{

						rated_battery_number: "",

					},
				],
				showVideo: false,
				monArr: [],
				videoObj: {},
				listQuery: {
					currentPage: 1,
					pageSize: 9,
					sort: 'desc'
				},
				showshipin1: false,
				inturnShow: 0,
				url: ''
			}
		},
		destroyed() {
			this.$bus.$off("updatetankuangEcharts1");
			this.clearVideojs();
		},
		mounted() {
			this.$bus.$on("updatetankuangEcharts1", () => {
				// console.log(99776666)
				
				this.getphotovoltaic();
				this.initVideo();
				
			});
			this.getphotovoltaic();
			this.initVideo();
			// this.getData();
		},
		methods: {
			nowType() {
				return localStorage.getItem("typeTime") || "日";
			},
			getphotovoltaic() {
				this.show1 = false;
				let params = {
					enCode: "powerplant-right-hdzjczb",
					"@station_id": localStorage.getItem("dummySattionId") ? localStorage.getItem("dummySattionId") :
						'0217fb691abe4b3abb5adb4ed72b590b'
				};
				dataInterface
					.dataFaceApi(params)
					.then((res) => {
						// console.log(res, "tankuangEcharts1");
						let data = res[0] || {};
						this.target[0].type = data.type || 0;
						this.target[1].rated_battery_number = data.rated_battery_number || 0;
						this.show1 = true;
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 清除videojs
			clearVideojs() {
				let videoObjTemp = Object.keys(this.videoObj);
				if (videoObjTemp && videoObjTemp.length) {
					videoObjTemp.forEach(v => {
						if (this.videoObj[v]) {
							this.videoObj[v].dispose()
						}
					})
				}
			},
			initVideo(stationId) {
				this.clearVideojs();
				this.videoObj = {}
				var params = {
					"stationId":
						// '0217fb691abe4b3abb5adb4ed72b590b'
						localStorage.getItem("dummySattionId") ? localStorage.getItem("dummySattionId") :
						'0217fb691abe4b3abb5adb4ed72b590b',
					// pageSize: this.listQuery.pageSize,
					// currentPage: this.listQuery.currentPage
				}
				this.showVideo = false

				this.url = ''
				dataInterface
					.gclVideoLiveInfoExposition1(params)
					.then((res) => {
						// console.log(res,'res111111jiankong')
						const stationVidio = res[0].stationVidio;
						this.showVideo = true
						dataInterface.selectUrlByCode({
							deviceCode: res[0].stationVidio
						}).then((res) => {
							this.url = res.url
							this.$nextTick(() => {
								const playerDom = this.$refs[`my-player`]
								Object.assign(this.videoObj, {
									[`video`]: videojs(
										playerDom, {
											autoplay: true, // 设置自动播放
											controls: true, // 显示播放的控件
											preload: 'metadata',
											aspectRatio: '16:9',
											fluid: true,
											sources: [
												// 注意，如果是以option方式设置的src,是不能实现 换台的 (即使监听了nowPlayVideoUrl也没实现)
												{
													src: this.url,

													type: 'application/x-mpegURL', // 告诉videojs,这是一个hls流
												},
											],
										},
										function() {},
									),
								})
							})
						})

					})
					.catch((err) => {
						console.log(err);
					});
			},
		},
	}
</script>

<style lang="scss" scoped>
	@import "./comm.scss";

	@font-face {
		font-family: "DS-Digital-Bold";
		src: url("~@/assets/font/DS-Digital-Bold.ttf");
	}

	.DS-Digital-Bold {
		font-family: "DS-Digital-Bold";
	}

	.imgRightTop {
		width: 100%;
		height: 100%;
		position: relative;

		img {
			display: block;
			position: absolute;
			top:0px;
			left: 50px;
			width: 2175px;
			height: 701px;
		}

		.tankuang {
			position: absolute;
			width: 1300px;
			height: 484px;
			top: 143px;
			right: 162px;
			background: url("~@/assets/images/exposition/xunidianchang-tanchuang.png")no-repeat;
			background-size: 100% 100%;

			.tankuang-top {
				height: 60px;
				padding-top: 7px;
				font-size: $FontSize28;
				line-height: 60px;
				display: flex;
				justify-content: space-between;
				padding-left: 35px;
				padding-right: 20px;

				.tankuang-top-left {
					display: block;
					width: 84px;
				}

				.tankuang-top-center {
					display: block;
					width: 336px;
				}

				.tankuang-top-right {
					display: block;
					width: 376px;
				}
			}

			.tankuang-bottom {
				height: 424px;
				width: 1296px;
				display: flex;

				.tankuang-bottom-left {
					width: 645px;
					padding-top: 20px;
				}

				.tankuang-bottom-right {
					width: 624px;
					height: 424px;
					padding-top: 38px;

					// padding-right: 30px;
					.jiankong {
						height: 330px;
					}

				}
			}
		}
	}
</style>
<style>
	.vjs-loading-spinner {
		opacity: 0;
	}
</style>